import { render, staticRenderFns } from "./Sketch.vue?vue&type=template&id=4d322a2c&scoped=true&"
import script from "./Sketch.vue?vue&type=script&lang=js&"
export * from "./Sketch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d322a2c",
  null
  
)

export default component.exports